import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/service/event.service';
import { FilterBaseComponent } from '../filter-base-component';

@Component({
    selector: 'app-filter-number',
    templateUrl: './filter-number.component.html',
    styleUrls: ['./filter-number.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterNumberComponent extends FilterBaseComponent implements OnInit {
  public value: number;
  
  constructor(protected _eventService: EventService, protected _translateService: TranslateService) {
    super(_eventService, _translateService);
  }
  
  ngOnInit() {
    this.baseSubscribeTranslationEvent();
    this.baseLoadTranslation();
  }

  ngOnDestroy(): void {
    this.baseOnDestroy()
  }

  // On ionBlur send value of filter
  public valueChanged(event) {         
    this._eventService.OnFilterValueChanged.next([this.Filter, event == null ? '' : event.toString()]);
  }
}
 